import { Col, Row } from "antd";
import { t } from "i18next";
import React, { useContext, useMemo, useState } from "react";

import { MandatoryField } from "../../../../../components/MandatoryField/MandatoryField";
import { MinistryContext } from "../../../../../modules/ministry/ministry.context";
import { IDozvolaZahteviDostavljeniDokaziProps } from "../../../../../modules/ministry/ministry.types";
import {
  AkcizneDozvoleDokumentiTipovi,
  MAX_UPLOAD_SIZE,
} from "../../../../../modules/obligee/exciseLicences/exciseLicences.constants";
import { ExciseLicencesContext } from "../../../../../modules/obligee/exciseLicences/exciseLicences.context";
import { AkciznaMarkicaKategorijaProzivoda } from "../../../../../modules/obligee/exciseStamps/exciseStamps.types";
import style from "./BottomPart.module.scss";
import { Document } from "./components/Document/Document";

interface IBottomPartProps {
  data?: IDozvolaZahteviDostavljeniDokaziProps[];
  isAddDocumentDisabled?: boolean;
  isRequired?: boolean;
}

export const BottomPart: React.FC<IBottomPartProps> = ({
  data,
  isRequired,
  isAddDocumentDisabled,
}) => {
  const { ministry } = useContext(MinistryContext);
  const { exciseLicences } = useContext(ExciseLicencesContext);
  const [availableFileSize, setAvailableFileSize] =
    useState<number>(MAX_UPLOAD_SIZE);

  const DocumentType2 = data?.find(
    (dokument: IDozvolaZahteviDostavljeniDokaziProps) =>
      dokument.tip ===
      AkcizneDozvoleDokumentiTipovi.OdobrenjeNadleznogOrganaZaKoriscenjeMernihUredjaja
  );
  const DocumentType3 = data?.find(
    (dokument: IDozvolaZahteviDostavljeniDokaziProps) =>
      dokument.tip === AkcizneDozvoleDokumentiTipovi.DokazOVlasnistvuIliZakupu
  );
  const DocumentType4 = data?.find(
    (dokument: IDozvolaZahteviDostavljeniDokaziProps) =>
      dokument.tip ===
      AkcizneDozvoleDokumentiTipovi.PostupakStecajaIliLikvidacije
  );
  const DocumentType6 = data?.find(
    (dokument: IDozvolaZahteviDostavljeniDokaziProps) =>
      dokument.tip ===
      AkcizneDozvoleDokumentiTipovi.KrivicniPostupakProtivOdgovornihLica
  );
  const DocumentType7 = data?.find(
    (dokument: IDozvolaZahteviDostavljeniDokaziProps) =>
      dokument.tip ===
      AkcizneDozvoleDokumentiTipovi.DokazOPopisuAkciznihProizvoda
  );

  const handleRequiredField = (translationKey: string) => {
    return isRequired ? MandatoryField(translationKey) : t(translationKey);
  };

  const evidencioniBroj = useMemo(
    () =>
      ministry.detaljiODozvoli?.evidencioniBroj ||
      exciseLicences.dozvolaInformacijeSkladista?.evidencioniBroj,
    [
      ministry.detaljiODozvoli?.evidencioniBroj,
      exciseLicences.dozvolaInformacijeSkladista?.evidencioniBroj,
    ]
  );

  return (
    <Col span={24} className={style.mainContainer}>
      <Col span={24} className={style.title}>
        {t("AKCIZNE_DOZVOLE.DOKUMENTACIJA")}
      </Col>
      <Row>
        <Col span={12} className="pr-55">
          <Row>
            <Col span={24}>
              <Document
                documentType={
                  AkcizneDozvoleDokumentiTipovi.DokazOVlasnistvuIliZakupu
                }
                data={DocumentType3 || null}
                isAddDocumentDisabled={isAddDocumentDisabled}
                dokumentName={
                  evidencioniBroj
                    ? `${evidencioniBroj}-${DocumentType3?.dokumentUrl}`
                    : ""
                }
                title={handleRequiredField(
                  "AKCIZNE_DOZVOLE.DOKAZ_O_VLASNISTVU_ZAKUPU"
                )}
                availableFileSize={availableFileSize}
                setAvailableFileSize={setAvailableFileSize}
              />
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Document
                documentType={
                  AkcizneDozvoleDokumentiTipovi.DokazOPopisuAkciznihProizvoda
                }
                data={DocumentType7 || null}
                title={handleRequiredField(
                  "AKCIZNE_DOZVOLE.DOKAZ_O_IZVRSENOM_POPISU_AKCIZNIH_PROIZVODA"
                )}
                isAddDocumentDisabled={isAddDocumentDisabled}
                dokumentName={
                  evidencioniBroj
                    ? `${evidencioniBroj}-${DocumentType7?.dokumentUrl}`
                    : ""
                }
                availableFileSize={availableFileSize}
                setAvailableFileSize={setAvailableFileSize}
              />
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Document
                documentType={
                  AkcizneDozvoleDokumentiTipovi.PostupakStecajaIliLikvidacije
                }
                data={DocumentType4 || null}
                title={handleRequiredField(
                  "AKCIZNE_DOZVOLE.POSTUPAK_STECAJA_ILI_LIKVIDACIJE"
                )}
                isAddDocumentDisabled={isAddDocumentDisabled}
                dokumentName={
                  evidencioniBroj
                    ? `${evidencioniBroj}-${DocumentType4?.dokumentUrl}`
                    : ""
                }
                availableFileSize={availableFileSize}
                setAvailableFileSize={setAvailableFileSize}
              />
            </Col>
          </Row>
        </Col>
        <Col span={12} className="pl-85">
          <Row>
            {exciseLicences.dozvolaInformacije?.kategorijaProizvodaId ===
            AkciznaMarkicaKategorijaProzivoda.DERIVATI_NAFTE ? (
              <Col span={24}>
                <Document
                  documentType={
                    AkcizneDozvoleDokumentiTipovi.OdobrenjeNadleznogOrganaZaKoriscenjeMernihUredjaja
                  }
                  data={DocumentType2 || null}
                  title={handleRequiredField(
                    "AKCIZNE_DOZVOLE.ODOBRENJE_OD_STRANE_ORGANA_NADLEZNOG_ZA_MERE_ZA_KORISCENJE_MERNOG_UREDJAJA"
                  )}
                  isAddDocumentDisabled={isAddDocumentDisabled}
                  dokumentName={
                    evidencioniBroj
                      ? `${evidencioniBroj}-${DocumentType2?.dokumentUrl}`
                      : ""
                  }
                  availableFileSize={availableFileSize}
                  setAvailableFileSize={setAvailableFileSize}
                />
              </Col>
            ) : null}
            <Row>
              <Col span={24}>
                <Document
                  documentType={
                    AkcizneDozvoleDokumentiTipovi.KrivicniPostupakProtivOdgovornihLica
                  }
                  data={DocumentType6 || null}
                  title={handleRequiredField(
                    "AKCIZNE_DOZVOLE.KRIVICNI_POSTUPAK_PROTIV_ODGOVORNOG_LICA"
                  )}
                  isAddDocumentDisabled={isAddDocumentDisabled}
                  dokumentName={
                    evidencioniBroj
                      ? `${evidencioniBroj}-${DocumentType6?.dokumentUrl}`
                      : ""
                  }
                  availableFileSize={availableFileSize}
                  setAvailableFileSize={setAvailableFileSize}
                />
              </Col>
            </Row>
          </Row>
        </Col>
      </Row>
    </Col>
  );
};
